import script from "./index.vue?vue&type=script&lang=js&setup=true"
export * from "./index.vue?vue&type=script&lang=js&setup=true"

import "./index.vue?vue&type=style&index=0&id=60628aac&lang=scss"

const __exports__ = script;

export default __exports__